import { POPULATE_PROFILE } from "store/types";

// null while the app asks the API who is signed in; false for a guest;
// the profile object once signed in.
const initialState = null;

export default function (state = initialState, action) {
  switch (action.type) {
    case POPULATE_PROFILE:
      return action.payload;

    default:
      return state;
  }
}
